import { WhatsAppIcon } from "./BrandIcon";
import { WHATSAPP_URL } from "@/content/site";

const WhatsAppButton = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Fale conosco no WhatsApp"
    title="Fale conosco no WhatsApp"
    className="fixed bottom-5 right-5 z-[60] grid h-14 w-14 place-items-center rounded-full bg-whatsapp text-white shadow-[0_12px_30px_-8px_rgb(37_211_102/.7)] transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-whatsapp/40"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </a>
);

export default WhatsAppButton;
